import React, { useEffect, useRef, useState } from "react";
import {
  getContacts,
  uploadFileContacts,
  uploadLinkContacts,
} from "../../constants";
import { ToastContainer, toast } from "react-toastify";

const ModalUploadContacts = ({ urlTemplate, setData, setUrlTemplate }) => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileType, setFileType] = useState(".vcf");
  const via = [
    "Contact File (Android)",
    "Contact File (Iphone)",
    "Excel",
    "Other Links",
  ];
  const tutorials = {
    "Contact File (Android)": [
      {
        main: "Download Virtual Contact File (.vcf) from your phone",
        child: [
          "Open Contacts App",
          "Tap the three-dot menu",
          "Select “Manage Contacts”",
          "Click “Export Contact”",
          "Choose where to save .vcf file on your device",
        ],
      },
    ],
    "Contact File (Iphone)": [
      {
        main: "Download Virtual Contact File (.vcf) from your phone",
        child: [
          "Open Contacts App",
          "Tap Lists in the top-left corner",
          "Long press on All Contacts",
          "Select Export",
          "Select contact fields",
          "Choose Save to Files",
        ],
      },
    ],
    Excel: [
      {
        main: `Download template file from <a href='${urlTemplate}' target='_blank'>this link<a/>`,
      },
      {
        main: "Fill in contact information using contact template",
      },
    ],
    "Other Links": [
      {
        main: `Get your link from other digital business provider (Hihello, Blinq, etc.)`,
      },
    ],
  };

  useEffect(() => {
    getContacts(token, setData, setUrlTemplate);
  }, [selectedFile, loading]);

  const [activeSection, setActiveSection] = useState(via[0]);

  const handleDivClick = () => {
    // 3. Trigger the file browser
    fileInputRef.current.click();
  };

  const handleFromLink = (e) => {
    e.preventDefault();
    uploadLinkContacts(token, url, setLoading);
  };

  const handleFileChange = (event) => {
    setLoading(true);
    const file = event.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    uploadFileContacts(token, file, setLoading, setSelectedFile);
  };

  useEffect(() => {
    if (activeSection.includes("Excel")) {
      setFileType(".xlsx");
    } else {
      setFileType(".vcf");
    }
  }, [activeSection]);

  return (
    <dialog id="upload_contacts_modal" className="modal shadow-2xl">
      <div className="modal-box flex flex-col justify-between max-w-none w-full md:w-[60%] p-10 h-fit">
        <div className="flex flex-col gap-5 mt-5">
          <div className="flex flex-row w-full" id="viaUpload">
            {via.map((v, i) => (
              <div
                className={`px-5 py-4 cursor-pointer hover:text-black ${
                  activeSection == v
                    ? "bg-gray-200 rounded-lg hover:text-secondary"
                    : ""
                }`}
                key={i}
                id={v}
                onClick={() => setActiveSection(v)}
              >
                {v}
              </div>
            ))}
          </div>
          <hr />
          <div className="font-bold">Instruction</div>
          <ul className="flex flex-col list-decimal ml-4 gap-5">
            {tutorials[activeSection].map((v, i) => (
              <>
                <li
                  key={i}
                  className="[&>a]:underline [&>a]:font-bold [&>a]:text-blue-500 [&>a]:cursor-pointer"
                  dangerouslySetInnerHTML={{ __html: v.main }}
                ></li>
                {v.child && (
                  <ul className="flex flex-col list-disc gap-3 ml-4">
                    {v.child.map((v_, i_) => (
                      <li key={i_ + 11}>{v_}</li>
                    ))}
                  </ul>
                )}
              </>
            ))}
            {activeSection != "Other Links" ? (
              <li className="">
                Upload your virtual contact file by click button{"  "}
                <input
                  type="file"
                  ref={fileInputRef}
                  className="hidden"
                  accept={fileType}
                  onChange={handleFileChange}
                />
                <span
                  className="ml-3 rounded-lg bg-primary text-white px-4
                py-2 hover:bg-secondary cursor-pointer"
                  onClick={handleDivClick}
                >
                  {loading ? (
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        className="w-6 h-6 text-gray-200 animate-spin fill-secondary"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="white"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="#E47410"
                        />
                      </svg>
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Upload"
                  )}
                </span>
              </li>
            ) : (
              <li className="">
                Paste your link here:
                <input
                  type="text"
                  value={url}
                  onChange={(e) => {
                    e.preventDefault();
                    setUrl(e.target.value);
                  }}
                  className="px-3 py-1 ml-3 border-0 border-b-2 focus:outline-none border-black w-[50%]"
                />
                <span
                  className="ml-3 rounded-lg bg-primary text-white px-4
                py-2 hover:bg-secondary cursor-pointer"
                  onClick={handleFromLink}
                >
                  {loading ? (
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        className="w-6 h-6 text-gray-200 animate-spin fill-secondary"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="white"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="#E47410"
                        />
                      </svg>
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Get data"
                  )}
                </span>
              </li>
            )}
          </ul>
        </div>
        <form
          method="dialog"
          className="flex flex-row justify-end items-center"
        >
          <button className="flex px-4 py-2 bg-primary text-white rounded-lg">
            Done
          </button>
        </form>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button>close</button>
      </form>
    </dialog>
  );
};

export default ModalUploadContacts;
